import { Controller } from "@hotwired/stimulus"

// Controller for preview pages to open popup
export default class extends Controller {
  static targets = ["popup"]

  // Keep clicks inside the popup (open trigger, close button, backdrop, links)
  // from bubbling to ancestor click handlers — e.g. an enclosing element that
  // opens a different modal on click.
  stop(event) {
    event.stopPropagation()
  }

  open() {
    // Find the actual popup wrapper div with the popup controller
    const popupWrapper = this.popupTarget.querySelector('[data-controller*="popup"]')
    
    if (!popupWrapper) {
      return
    }
    
    // Remove hidden class to show popup
    popupWrapper.classList.remove("hidden")
    this.popupTarget.classList.remove("hidden")
    
    // Wait for next frame to ensure DOM is updated, then initialize
    requestAnimationFrame(() => {
      const popupController = this.application.getControllerForElementAndIdentifier(popupWrapper, "popup")
      if (popupController) {
        popupController.initialize()
      } else {
        // If controller doesn't exist yet, wait a bit more
        setTimeout(() => {
          const popupController = this.application.getControllerForElementAndIdentifier(popupWrapper, "popup")
          if (popupController) {
            popupController.initialize()
          }
        }, 50)
      }
    })
  }
}
